/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { SignInState } from "./signIn.types";
import { IP_AUTO_LOGIN_STATUS_IDLE } from "./signIn.types";

/**
 * The single initial state for the sign-in slice. Every flow-specific
 * reducer group mutates this shape, so it lives on its own rather than
 * inside any one of them.
 */
export const INITIAL_STATE: SignInState = {
  isInitializing: false,
  isInitialized: false,
  initError: "",
  initErrorCode: "",
  initErrorServiceCode: "",
  authConfigurations: [],
  activeTab: "",
  userId: "",
  password: "",
  isPasswordVisible: false,
  authCode: "",
  qrCodeUrl: "",
  qrCodeBitmap: "",
  focusedField: "tab",
  isSigningIn: false,
  signInError: "",
  signInErrorCode: "",
  signInErrorServiceCode: "",
  domainToken: null,
  provisionResponse: undefined,
  isTokenRehydrating: true,
  isRefreshingToken: false,
  refreshError: "",
  recoveryEmail: "",
  isSendingResetLink: false,
  sendResetLinkError: "",
  isResetTokenValidating: false,
  resetTokenValidationError: "",
  resetIdentityPayload: null,
  isUpdatingPassword: false,
  updatePasswordError: "",
  isPasswordResetComplete: false,
  mobileDialogDismissed: false,
  // DBS state
  dbsFlowStatus: "idle",
  dbsToken: "",
  dbsTokenExpiration: 0,
  licensePlateCode: "",
  licensePlateCredential: "",
  pollingIntervalSeconds: 0,
  licensePlateExpirationTime: "",
  licensePlateBindingUrl: "",
  licensePlateBindingCredentialUrl: "",
  dbsJwtToken: "",
  dbsPollingStatus: "idle",
  dbsError: null,
  // IP auto-login orchestration state
  authOrchestrationStatus: "idle",
  attemptedAuthTypes: [],
  ipAutoLoginStatus: IP_AUTO_LOGIN_STATUS_IDLE,
  ipAutoLoginError: null,
  resolvedAuthType: ""
};
